<template>
  <div id="joinPage" class="container">
    <router-link :to="{ name: 'loginPage' }">
      <img
        class="logo"
        :src="`/images/logo-font-${isDark ? 'white' : 'black'}.svg`"
        alt="Logo yuzu"
      />
    </router-link>
    <h2>Créer votre compte Yuzu</h2>
    <p>Pour rejoindre votre équipe</p>
    <transition mode="out-in" name="fade">
      <Form :isLoading="state.isLoading" @validation="createUser" />
    </transition>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useDark } from "@vueuse/core";
import { useToast } from "vue-toastification";
import { useUserStore } from "@/stores/user.js";
import { useRoute } from "vue-router";
import { getError } from "@/composables/error.js";
import Form from "./partials/Form.vue";

const isDark = useDark();

const route = useRoute();

const toast = useToast();

const userStore = useUserStore();

const emits = defineEmits(["success"]);

const state = reactive({
  isLoading: false,
});

async function createUser() {
  state.isLoading = true;

  const resp = await userStore.registerFromMember(route.query.invitation_id);

  if (resp.user && resp.user.user_id) {
    await userStore.getUser("loginPage");
    emits("success");
  } else if (resp.code === 409) {
    toast.error(getError(resp.key));
  } else {
    toast.error("Invitation invalide.");
  }

  state.isLoading = true;
}
</script>
